// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__LfnWC","title":"BackImages_title__3tycy","images":"BackImages_images__18er9"};